/* eslint-disable
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import CampaignConstants from 'constants/CampaignConstants'
import { captureException, captureResponseException } from 'utils/SentryHelpers'

const FAIL_MESSAGE = "Something went wrong! Your test email couldn't be sent"
const SUCCESS_MESSAGE = 'Your test email has been sent!'

const CampaignActions = Marty.createActionCreators({
  createCampaign(body, requestId) {
    return this.app.queries.CampaignQueries.createCampaign(body, requestId)
  },

  updateCampaign(id, update) {
    return this.app.queries.CampaignQueries.updateCampaign(id, update)
  },

  updateCampaignOld(id, update) {
    return this.app.queries.CampaignQueries.updateCampaignOld(id, update)
  },

  pushCampaign(campaign) {
    return this.dispatch(
      CampaignConstants.CAMPAIGN_UPDATE_DONE,
      campaign.id,
      campaign
    )
  },

  /**
   * Sends a test email campaign to a list of users.
   * @param {Object} campaign - The email campaign to send
   * @param {string[]} emails - A list of recipients' email addresses
  */
  sendTestCampaign(campaign, emails) {
    this.dispatch(CampaignConstants.SEND_TEST_CAMPAIGN_STARTING, campaign, emails)

    const promise = this.app.sources.CampaignAPI.sendTestCampaign(campaign, emails)

    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(
          CampaignConstants.SEND_TEST_CAMPAIGN_DONE, res.body, campaign, emails)
        return this.app.actions.NotificationActions.pushNotification({
          content: SUCCESS_MESSAGE
        })
      } else {
        captureResponseException(res)
        this.dispatch(
          CampaignConstants.SEND_TEST_CAMPAIGN_FAILED, campaign, emails, res)
        return this.notifyTestCampaignFailed()
      }
    })

    return promise.catch(error => {
      captureException(error)
      this.dispatch(CampaignConstants.SEND_TEST_CAMPAIGN_FAILED, requestId, error)
      return this.notifyTestCampaignFailed()
    })
  },

  notifyTestCampaignFailed() {
    return this.app.actions.NotificationActions.pushNotification({
      content: FAIL_MESSAGE,
      variant: 'red'
    })
  },

  saveAnnouncementDraft(update) {
    return this.dispatch(CampaignConstants.SAVE_ANNOUNCEMENT_DRAFT, update)
  },

  saveNPSDraft(update) {
    return this.dispatch(CampaignConstants.SAVE_NPS_DRAFT, update)
  }
})

export default CampaignActions



// WEBPACK FOOTER //
// ./src/scripts/actions/CampaignActions.js